import { Modal } from "../components/Modal/Modal";
import { useWindowDimensions } from "../hooks";

const VIEWPORT_USAGE_TRESHOLD = 1024;

export function ViewportModal() {
  const { width } = useWindowDimensions();

  return (
    <Modal visible={width < VIEWPORT_USAGE_TRESHOLD} showClose={false}>
      <p className="mb-4 font-bold">Browser window too small</p>
      <p>
        This app works best on screens over{" "}
        <strong>{VIEWPORT_USAGE_TRESHOLD} pixels</strong> wide.
      </p>
      <p>Current width: {width} pixels</p>
      <p>Make the window larger</p>
    </Modal>
  );
}
